export var StatusOffer;
(function (StatusOffer) {
    StatusOffer["ACTIVE"] = "active";
})(StatusOffer || (StatusOffer = {}));
export var StagingStatusOffer;
(function (StagingStatusOffer) {
    StagingStatusOffer["PENDING"] = "pending";
    StagingStatusOffer["PUBLISHED"] = "published";
    StagingStatusOffer["REFUSED"] = "refused";
})(StagingStatusOffer || (StagingStatusOffer = {}));
export var OfferRefuseReason;
(function (OfferRefuseReason) {
    OfferRefuseReason["INCOMPLETE_INFO"] = "incompleteInfo";
    OfferRefuseReason["INEXACT_ILLEGAL_INFO"] = "inexactIllegalInfo";
    OfferRefuseReason["BABYSITTING_OFFER"] = "babysittingOffer";
    OfferRefuseReason["PRIVATE_LESSON"] = "privateLesson";
    OfferRefuseReason["NATIVE_SPEAKER"] = "nativeSpeaker";
    OfferRefuseReason["SALARY_NOT_FAIR"] = "salaryNotFair";
    OfferRefuseReason["ESTABLISHMENT_OUTSIDE_FRANCE"] = "establishmentOutsideFrance";
})(OfferRefuseReason || (OfferRefuseReason = {}));
export var OfferTypeValues;
(function (OfferTypeValues) {
    OfferTypeValues["LONG_TERM"] = "longTerm";
    OfferTypeValues["SHORT_TERM"] = "shortTerm";
})(OfferTypeValues || (OfferTypeValues = {}));
export var EmploymentTypeValues;
(function (EmploymentTypeValues) {
    EmploymentTypeValues["FULL_TIME"] = "fullTime";
    EmploymentTypeValues["PART_TIME"] = "partTime";
})(EmploymentTypeValues || (EmploymentTypeValues = {}));
export var ContractTypeValues;
(function (ContractTypeValues) {
    ContractTypeValues["CDI"] = "CDI";
    ContractTypeValues["CDD"] = "CDD";
    ContractTypeValues["CDII"] = "CDII";
    ContractTypeValues["CDDU"] = "CDDU";
    ContractTypeValues["INTERNSHIP"] = "internship";
    ContractTypeValues["FREELANCE"] = "freelance";
    ContractTypeValues["OTHER"] = "other";
})(ContractTypeValues || (ContractTypeValues = {}));
export var TeachingTypeValues;
(function (TeachingTypeValues) {
    TeachingTypeValues["IN_PERSON"] = "inPerson";
    TeachingTypeValues["HYBRID"] = "hybrid";
    TeachingTypeValues["ONLINE_DISTANCE"] = "onlineDistance";
})(TeachingTypeValues || (TeachingTypeValues = {}));
export var JobTitleValues;
(function (JobTitleValues) {
    JobTitleValues["TEACHER"] = "teacher";
    JobTitleValues["INTERN"] = "intern";
    JobTitleValues["TEACHING_ASSISTANT"] = "teachingAssistant";
    JobTitleValues["COORDINATOR_MANAGER"] = "coordinatorManager";
    JobTitleValues["EXAMINER"] = "examiner";
    JobTitleValues["INVIGILATOR"] = "invigilator";
    JobTitleValues["TRANSLATOR"] = "translator";
    JobTitleValues["INTERPRETER"] = "interpreter";
    JobTitleValues["PRINCIPAL"] = "principal";
    JobTitleValues["COACH_TRAINER"] = "coachTrainer";
    JobTitleValues["TUTOR"] = "tutor";
    // CHILDMINDER = 'childminder',
})(JobTitleValues || (JobTitleValues = {}));
export var LevelValues;
(function (LevelValues) {
    LevelValues["NURSERY"] = "nursery";
    LevelValues["EARLY_YEARS"] = "earlyYears";
    LevelValues["PRIMARY"] = "primary";
    LevelValues["MIDDLE_SCHOOL"] = "middleSchool";
    LevelValues["HIGH_SCHOOL"] = "highSchool";
    LevelValues["HIGHER_EDUCATION"] = "higherEducation";
    LevelValues["PROFESSIONAL"] = "professional";
})(LevelValues || (LevelValues = {}));
const levelOrder = {
    [LevelValues.NURSERY]: 0,
    [LevelValues.EARLY_YEARS]: 1,
    [LevelValues.PRIMARY]: 2,
    [LevelValues.MIDDLE_SCHOOL]: 3,
    [LevelValues.HIGH_SCHOOL]: 4,
    [LevelValues.HIGHER_EDUCATION]: 5,
    [LevelValues.PROFESSIONAL]: 6,
};
export const compareLevels = (a, b) => {
    return levelOrder[a] - levelOrder[b];
};
export var SubjectValues;
(function (SubjectValues) {
    SubjectValues["ENGLISH"] = "english";
})(SubjectValues || (SubjectValues = {}));
export default {
    StatusOffer,
    StagingStatusOffer,
    OfferTypeValues,
    JobTitleValues,
    LevelValues,
    SubjectValues,
    EmploymentTypeValues,
    ContractTypeValues,
    TeachingTypeValues,
};
